module.exports = __webpack_public_path__ + "img/logo-mo-34.ee045aa4.svg";